import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-easy-interface',
  templateUrl: './icon-easy-interface.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconEasyInterfaceComponent {}
